// extracted by mini-css-extract-plugin
export default {"style":"Pagination_style__l9fTt"};